export const updatingFieldDescription = state =>
  state.formsV2.fields.updatingFieldDescription;
export const selectedFormField = state =>
  state.formsV2.fields.selectedFormField;
